import React, {useCallback, useEffect, useMemo, useState} from "react";
import {Button, Cascader, Divider, Form, Modal, MultiCascader, Stack} from 'rsuite';
import {ArrowRightLine} from "@rsuite/icons";
import {mergeSkills} from "../../../../service/adminService";

const viewerModalGridStyle = {
    justifyItems: 'center',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr'
};

const SkillCleanupModal = (props) => {
    const { open, handleClose, unformattedSkills } = props;

    const [skillBuckets, setSkillBuckets] = useState([]);
    const [localState, setLocalState] = useState({});

    useEffect(() => {
        const skillBuckets = {};
        unformattedSkills.forEach((skill) => {
            if (skillBuckets[skill.skillType] === undefined) {
                skillBuckets[skill.skillType] = [];
            }
            skillBuckets[skill.skillType].push({label: skill.skillName, value: skill.id});
        });
        const treeData = [];
        Object.keys(skillBuckets).forEach((key) =>  {
            const row = {label: key, value: key};
            row.children = skillBuckets[key];
            treeData.push(row);
        });
        setSkillBuckets(treeData);
    }, [unformattedSkills]);

    const localClose = useCallback((response) => {
        setLocalState({});
        handleClose(response);
    }, [handleClose]);

    const submitSkillMerge = useCallback((isFormValid) => {
        if(!isFormValid) return;
        mergeSkills(localState).then((response) => {
            localClose(response);
        });
    }, [localState, localClose]);

    const isValidMergeRequest = useCallback(() => {
        return localState.sourceSkills?.length > 0 && localState.targetSkill !== undefined &&
            localState.targetSkill !== null &&
            !localState.sourceSkills?.includes(localState.targetSkill);
    }, [localState]);

    // rsuite does not have an onSubmit, we must handle state changes per controlled field
    const handleFormChange = useCallback((event) => {
        setLocalState({...localState, ...event});
    }, [localState]);

    return useMemo(() => {
            return (
                <Modal
                    open={open}
                    onClose={() => localClose({})}
                    backdrop="static"
                    size="md"
                >
                    <Modal.Header>
                        <Modal.Title>Skill Cleanup</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Stack spacing={2} direction='column' alignItems='flex-start'>
                            <p>
                                Merge one to many skills into an existing Skill.
                            </p>
                            <p>
                                This updates all users of the selected skills to have the new skill.
                                The old skills are then deleted.
                            </p>
                            <p>
                                <b>A skill cannot both be a source and the target.</b>
                            </p>
                        </Stack>
                        <Divider />
                        <Form
                            style={viewerModalGridStyle}
                            onChange={handleFormChange}
                            onSubmit={submitSkillMerge}
                            formValue={localState}
                        >
                            <Form.Group>
                                <Form.ControlLabel>Source Skills</Form.ControlLabel>
                                <Form.Control name="sourceSkills"
                                              menuWidth={300}
                                              menuHeight={300}
                                              accepter={MultiCascader}
                                              data={skillBuckets}
                                              style={{ width: 300 }}
                                              uncheckableItemValues={skillBuckets.map((item) => item.label)}
                                />
                            </Form.Group>
                            <ArrowRightLine style={{fontSize: "3em", marginTop: "0.5em"}}/>
                            <Form.Group>
                                <Form.ControlLabel>Target Skill</Form.ControlLabel>
                                <Form.Control name="targetSkill"
                                              menuWidth={300}
                                              menuHeight={300}
                                              accepter={Cascader}
                                              data={skillBuckets}
                                              style={{ width: 300 }}
                                />
                            </Form.Group>
                            {/*Dummy divs for grid css*/}
                            <div />
                            <Button type="submit" appearance="primary" disabled={!isValidMergeRequest()}>
                                Merge
                            </Button>
                            <div />
                        </Form>
                    </Modal.Body>
                </Modal>
            );
        },
        [
            skillBuckets,
            localClose,
            open,
            handleFormChange,
            submitSkillMerge,
            localState,
            isValidMergeRequest
        ]
    );
}

export default SkillCleanupModal;